'use client';

import { useEffect, useState } from 'react';
import { CircleHelp } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';

import { getSocialLinks } from '@/app/[locale]/store/actions';
import { cn } from '@/lib/utils';
import { SocialLink } from '@/types/social';

interface SocialButtonsProps {
    isMenu?: boolean;
}

export const SocialButtons = ({ isMenu = false }: SocialButtonsProps) => {
    const [isLoading, setIsLoading] = useState(true);
    const [socialLinks, setSocialLinks] = useState<SocialLink[]>([]);

    useEffect(() => {
        const fetchSocialLinks = async () => {
            const links = await getSocialLinks();
            setSocialLinks(links);
            setIsLoading(false);
        };

        fetchSocialLinks();
    }, []);

    const hasSocialLinks = socialLinks && socialLinks.length > 0;

    if (isLoading || !hasSocialLinks) {
        return;
    }

    return (
        <div
            className={cn(
                'flex lg:h-[24px] h-[56px] items-center justify-center gap-4 px-4 [&_svg]:shrink-0',
                isMenu && 'bg-white-alpha-10',
            )}
        >
            {socialLinks.map(social => {
                return (
                    <Link
                        key={`social-${social.id}`}
                        href={social.link}
                        target='_blank'
                        className='flex size-6 items-center'
                    >
                        {social.image ? (
                            <Image
                                src={social.image}
                                alt={social.image}
                                width={24}
                                height={24}
                                className='transition-opacity hover:opacity-80'
                            />
                        ) : (
                            <div className='bg-white-alpha-10 flex size-6 items-center justify-center rounded-full'>
                                <CircleHelp className='size-4 text-white' />
                            </div>
                        )}
                    </Link>
                );
            })}
        </div>
    );
};
